var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: _vm.modalRef,
      attrs: {
        title: _vm.modalTitle || "テンプレートを選択",
        lazy: "",
        centered: "",
      },
      on: {
        ok: _vm.onSelectionSaved,
        cancel: _vm.onSelectionCanceled,
        shown: _vm.onShownModal,
        hide: _vm.clear,
      },
    },
    [
      _c("b-form-input", {
        ref: "input",
        attrs: { type: "text", placeholder: "テンプレート名で絞り込む" },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            ) {
              return null
            }
            $event.preventDefault()
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            ) {
              return null
            }
            return _vm.focusTree($event)
          },
          input: _vm.onSearchStringChanged,
        },
        model: {
          value: _vm.searchString,
          callback: function ($$v) {
            _vm.searchString = $$v
          },
          expression: "searchString",
        },
      }),
      _vm._v(" "),
      _c("tree", {
        ref: "wikiPageTemplatesTree",
        attrs: {
          data: _vm.wikiPageTemplates,
          filter: _vm.filter,
          options: _vm.wikiPageTemplatesOptions,
        },
        on: { "node:selected": _vm.onWikiPageTemplateSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }